let initialState={payload:{msg:'fetching',data:[]},action:"success"};
let inspectorInspection =(state=initialState.payload,action)=>{
    switch(action.type){
        case "success":{
                state={
                data:action.payload,
                msg:'fetched'
            };
            break;
        }
        default:{}

    }
return state;
}

export default inspectorInspection;


// WEBPACK FOOTER //
// ./src/redux/reducers/inspector/inspection.js